import React from 'react';

const modalStyles = {
    overlay: {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
    },
    content: {
        backgroundColor: '#161B22', color: 'white', padding: '2rem', borderRadius: '8px',
        maxWidth: '500px', width: '90%', textAlign: 'center', border: '1px solid #30363d', position: 'relative',
    },
    closeButton: {
        position: 'absolute', top: '10px', right: '15px', background: 'none', border: 'none',
        color: 'white', fontSize: '1.5rem', cursor: 'pointer',
    },
    title: { fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem', color: 'white' },
    text: { color: '#a0aec0', marginBottom: '1.5rem' },
    buttonContainer: { display: 'flex', flexDirection: 'column', gap: '1rem' },
    confirmButton: {
        backgroundColor: '#22d3ee', color: '#0f172a', fontWeight: 'bold',
        padding: '0.75rem 1.5rem', borderRadius: '8px', border: 'none', cursor: 'pointer',
    },
    declineButton: {
        backgroundColor: 'transparent', color: '#22d3ee', fontWeight: 'bold',
        padding: '0.75rem 1.5rem', borderRadius: '8px', border: '1px solid #22d3ee', cursor: 'pointer',
    },
    // --- Estilos para el nuevo bloque de precio total ---
    totalPriceContainer: {
        backgroundColor: 'rgba(45, 212, 191, 0.1)',
        border: '1px dashed #22d3ee',
        borderRadius: '8px',
        padding: '1rem',
        margin: '1.5rem 0',
    },
    totalPriceLabel: {
        display: 'block', fontSize: '1rem', color: '#a0aec0', marginBottom: '0.25rem',
    },
    totalPriceValue: {
        display: 'block', fontSize: '2.5rem', fontWeight: 'bold', color: '#ffffff',
    },
};

const UpsellModal = ({ show, course, newPrice, currency, country, handleClose, onConfirm, onDecline }) => {
    if (!show) {
        return null;
    }

    const priceCourse = course.values[country].newPrice;
    const idCourse = course.id;
    const extraCostValue = priceCourse - newPrice;
    const totalCost = idCourse != '10' ? `${priceCourse.toLocaleString("de-DE")} ${currency}` : `${(priceCourse+extraCostValue).toLocaleString("de-DE")} ${currency}`;
    const extraCost = `${extraCostValue.toLocaleString("de-DE")} ${currency}`;
    const courseName = course.titleMain;

    if (idCourse != '10') {
        return (

            <div style={modalStyles.overlay} onClick={handleClose}>
                <div style={modalStyles.content} onClick={(e) => e.stopPropagation()}>
                    <button style={modalStyles.closeButton} onClick={handleClose}>&times;</button>
                    <h2 style={modalStyles.title}>¡Espera! Una Oferta Irresistible 🚀</h2>
                    <p style={modalStyles.text}>
                        Por solo <strong style={{ color: '#22d3ee' }}>{extraCost} adicionales</strong>, lleva tu aprendizaje al siguiente nivel con acceso completo a nuestro curso online: <strong>"{courseName}"</strong>.
                    </p>

                    <div style={modalStyles.totalPriceContainer}>
                        <span style={modalStyles.totalPriceLabel}>Lleva TODO (Ebook + Curso) por:</span>
                        <span style={modalStyles.totalPriceValue}>{totalCost}</span>
                    </div>

                    <div style={modalStyles.buttonContainer}>
                        <button style={modalStyles.confirmButton} onClick={onConfirm}>
                            ¡Sí, quiero el paquete completo!
                        </button>
                        <button style={modalStyles.declineButton} onClick={onDecline}>
                            No, gracias. Solo quiero el Ebook.
                        </button>
                    </div>
                </div>
            </div>
        );
    }
    return (

        <div style={modalStyles.overlay} onClick={handleClose}>
            <div style={modalStyles.content} onClick={(e) => e.stopPropagation()}>
                <button style={modalStyles.closeButton} onClick={handleClose}>&times;</button>
                <h2 style={modalStyles.title}>¡Espera! Una Oferta Irresistible 🚀</h2>
                <p style={modalStyles.text}>
                    Por solo <strong style={{ color: '#22d3ee' }}>{extraCost} adicionales</strong>, puedes obtener la grabación completa del taller: <strong>"{courseName}"</strong> en tu correo para repasar a futuro.
                </p>

                <div style={modalStyles.totalPriceContainer}>
                    <span style={modalStyles.totalPriceLabel}>Lleva TODO (Grabación + Taller) por:</span>
                    <span style={modalStyles.totalPriceValue}>{totalCost}</span>
                </div>

                <div style={modalStyles.buttonContainer}>
                    <button style={modalStyles.confirmButton} onClick={onConfirm}>
                        ¡Sí, quiero el paquete completo!
                    </button>
                    <button style={modalStyles.declineButton} onClick={onDecline}>
                        No, gracias. Solo quiero el Taller.
                    </button>
                </div>
            </div>
        </div>
    );

};

export default UpsellModal;